import { AccumulatedResults, NoResults } from "@kaltura/mediaspace-shared-search";
import { KalturaESearchEntryResult } from "kaltura-typescript-client/api/types/KalturaESearchEntryResult";
import { SearchResultsWithLoadMore } from "./SearchResultsWithLoadMore";
import { SearchResultsDataProps } from "../search-results-data/SearchResultsData";

/**
 * Props for SearchResultsData component with load-more pagination.
 * Extends SearchResultsDataProps and adds load-more specific functionality.
 */
export interface SearchResultsDataWithLoadMoreProps extends SearchResultsDataProps {
    /**
     * Callback to load more results
     */
    onLoadMore: () => void;
    /**
     * Whether currently loading more results
     */
    isLoadingMore?: boolean;
    /**
     * Function to update the cached results
     * The oldData and return type use AccumulatedResults structure with entryResults
     */
    updateCachedResults?: (
        updater: (
            oldData: AccumulatedResults<KalturaESearchEntryResult>
        ) => AccumulatedResults<KalturaESearchEntryResult>
    ) => void;
}

/**
 * Search result data with load more functionality for suspense below the container level
 */
export function SearchResultsDataWithLoadMore(props: SearchResultsDataWithLoadMoreProps) {
    const {
        isSearch,
        isTextSearch,
        fetchModuleData,
        onEntryShowMore,
        pageSize,
        isWideLayout,
        searchInLabel,
        bulkButtonActions,
        bulkMenuActions,
        onInvalidate,
        onData,
        noMediaComponent: NoMediaComponent,
        noMediaComponentProps,
        additionalInvalidation,
        filterValues,
        areSearchResultsDraggable = false,
        header,
        mediaCard,
        onLoadMore,
        isLoadingMore = false,
        updateCachedResults,
    } = props;

    const { data } = fetchModuleData();
    onData?.(data);

    return (
        <>
            {data && (
                <SearchResultsWithLoadMore
                    {...data}
                    isTextSearch={isTextSearch}
                    pageSize={pageSize}
                    onEntryShowMore={onEntryShowMore}
                    isWideLayout={isWideLayout}
                    searchInLabel={searchInLabel}
                    bulkButtonActions={bulkButtonActions}
                    bulkMenuActions={bulkMenuActions}
                    onInvalidate={onInvalidate}
                    additionalInvalidation={additionalInvalidation}
                    filterValues={filterValues}
                    areSearchResultsDraggable={areSearchResultsDraggable}
                    header={header}
                    mediaCard={mediaCard}
                    onLoadMore={onLoadMore}
                    isLoadingMore={isLoadingMore}
                    updateCachedResults={updateCachedResults}
                />
            )}
            {!data && isSearch && <NoResults screenMode="nomatches" />}
            {!data && !isSearch && <NoMediaComponent {...noMediaComponentProps} />}
        </>
    );
}
